import React, { Component } from 'react'
import { withRouter } from 'react-router'
import compose from '@shopify/react-compose'

import { withEndUser } from '@portal/kit/pkg/components'

import RequestNumber from './request-phone-number'
import ValidationCode from './validation-code'

class EditPhoneNumberContainer extends Component {

  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      step: !props.user.data.phone_number_change_request ? 1 : 2,
    }
  }

  nextStep = () => {
    const { step } = this.state
    this.setState({ step: step + 1 })
  }

  previousStep = () => {
    const { step } = this.state
    this.setState({ step: step - 1 })
  }

  render() {
    const { step } = this.state

    return step === 1 ?
      <RequestNumber
        nextStep={this.nextStep}
        user={this.props.user}
      />
      : step === 2 ?
      <ValidationCode
        previousStep={this.previousStep}
        user={this.props.user}
      />
      : null
  }

}

EditPhoneNumberContainer.propTypes = {}

export default compose(
  withRouter,
  withEndUser,
)(EditPhoneNumberContainer)
